import _ from "lodash";
import React from "react";
import classes from "./CheckOTP.scss";
import OtpInput from "UIComponents/OtpInput";
import { colors, fontStyle } from "Constants";
import { Button } from "@toddle-edu/ds-web";

const INPUT_LENGTH = 6;

const styles = {
  inputStyle: {
    width: "100%",
    height: "112px",
    margin: "4px",
    fontSize: "3.2rem",
    borderRadius: 4,
    border: "1px solid",
    borderColor: colors.strokeOne,
    outline: "none",
    ...fontStyle.medium,
  },
  focusStyle: {
    borderColor: colors.neutral400,
    outline: "none",
  },
};

const CheckOTP = props => {
  const {
    renderBackButtonComponent,
    onBackClick,
    onConfirmClick,
    customStyle: {
      containerStyle,
      headerStyle,
      subTextStyle,
      confirmBtnStyle,
    } = {},
    isLoading,
    heading,
    subHeading,
    renderCreateAccountPrivacyText,
    otp,
    updateInputField,
  } = props;

  const onEnter = () => {
    const { data: { otp } = {} } = props;
    const isPending = _.get(otp, "length", 0) != INPUT_LENGTH;
    if (isPending) {
      return;
    }
    onConfirmClick();
  };

  const onChangeOTP = otp => {
    updateInputField({ otp });
  };

  return (
    <div className={classes.container} style={containerStyle}>
      {renderBackButtonComponent({ onClick: onBackClick })}
      <div style={headerStyle}>{heading} </div>
      <div style={subTextStyle}>{subHeading}</div>
      <div className={classes.innerContainer}>
        <div className={classes.inputsContainer}>
          <OtpInput
            inputStyle={styles.inputStyle}
            focusStyle={styles.focusStyle}
            numInputs={INPUT_LENGTH}
            hasErrored={false}
            onChange={onChangeOTP}
            separator={<span />}
            isInputNum={false}
            shouldAutoFocus
            value={otp}
            isDisabled={!!isLoading}
            onEnter={onEnter}
          />
        </div>
        <div className={classes.bottomContainer}>
          {renderCreateAccountPrivacyText &&
            renderCreateAccountPrivacyText({
              buttonText: "Verify",
            })}
          <div className={classes.confirmButton} style={confirmBtnStyle}>
            <Button
              size="large"
              onClick={onConfirmClick}
              disabled={_.get(otp, "length", 0) != INPUT_LENGTH}
              isFullWidth={true}
            >
              {"Verify"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckOTP;
